import React, { useState } from "react";
import PropTypes from "prop-types";
import reactStringReplace from "react-string-replace";
import { PageLayout } from "../../../../components";
import { FilePicker } from "../../components";
import { formatImagesForPost, getIsInValid, tryAgain } from "../../helpers";
import { useSelector, useDispatch } from "react-redux";
import { selectImageUploadData } from "../../../../store/selectors";
import { imageUploadSlice } from "../../../../store/slices/ImageUploads";
import OdometerAlert from "../../../../components/OdometerAlert";
import { MobilePhotoActions } from "../../../../components/MobilePhotoActions/MobilePhotoActions";

export default function MilageOnlyUpload({ currentHelper, handleChange }) {
  const { maxUploads, mobileDeviceWithCamera } = useSelector(
    selectImageUploadData
  );
  const {
    label,
    helperText,
    boldLabelText,
    boldHeaderText,
    imageQuantityRequired,
    boldHeaderTextAdditional,
    image
  } = currentHelper;
  const [validation, setValidation] = useState(null);
  const dispatch = useDispatch();

  const helperTextBelowImage = reactStringReplace(
    helperText,
    boldLabelText,
    (match, i) => (
      <span key={`${match}-${i}`}>
        <b>{match}</b>
      </span>
    )
  );

  const labelWithFirstInstanceBoldenedWords = reactStringReplace(
    label,
    boldHeaderText,
    (match, i) => (
      <span key={`${match}-${i}`}>
        <b>{match}</b>
      </span>
    )
  );

  const helperTextAboveImage = reactStringReplace(
    labelWithFirstInstanceBoldenedWords,
    boldHeaderTextAdditional,
    (match, i) => {
      if (!match) return;
      return (
        <span key={`${match}-${i}`}>
          <b>{match}</b>
        </span>
      );
    }
  );

  const onChange = (imageFiles, mobileImageLastAction) => {
    dispatch(
      imageUploadSlice.actions.setMobileImageLastAction(mobileImageLastAction)
    );
    const validationWarning = getIsInValid(imageFiles, maxUploads);
    if (!validationWarning) {
      const images = formatImagesForPost(currentHelper, imageFiles);
      handleChange(images);
      dispatch(
        imageUploadSlice.actions.setMaxUploads(maxUploads - imageFiles.length)
      );
    } else {
      setValidation(validationWarning);
    }
  };

  return (
    <PageLayout>
      <PageLayout.Header title="Record mileage" step={2} steps={2} />
      <PageLayout.Content>
        <>
          <p className="ch-fs--4" aria-label={label}>
            {helperTextAboveImage}
          </p>
          <div className="tip-card ch-bg--white ch-ba--1 ch-bc--grey-3">
            <span className="tip-card__example-flag ch-color--white ch-ph--1">
              EXAMPLE
            </span>
            <img
              src={image}
              className="tip-card__example-img"
              alt="example-upload"
              onError={(e) => tryAgain(e.target)}
            />
          </div>
          <div className="ch-bg--grey-1 ch-br--1 ch-bl--1 ch-bb--1 ch-bc--grey-3 ch-pa--3 ch-shadow--sm">
            <p className="ch-fs--4">Upload {helperTextBelowImage}</p>
          </div>
        </>
        {validation && (
          <div className="ch-form__group ch-form__group--error">
            <span className="ch-form__control-validation ">{validation}</span>
          </div>
        )}
        <OdometerAlert />
      </PageLayout.Content>
      <PageLayout.Footer>
        {mobileDeviceWithCamera ? (
          <MobilePhotoActions
            imageQuantityRequired={imageQuantityRequired}
            onChange={onChange}
            uploadMore={false}
            labelIdentifier={"mobile-photo-action"}
            disable={false}
          />
        ) : (
          <FilePicker
            buttonLabel={`Upload photo${imageQuantityRequired > 1 ? "s" : ""}`}
            buttonClass="ch-btn--success ch-btn--block ch-mh--auto ch-width--12 sl:ch-width--8 sm:ch-width--5 md:ch-width--4"
            handleChange={onChange}
          />
        )}
      </PageLayout.Footer>
    </PageLayout>
  );
}

MilageOnlyUpload.propTypes = {
  currentHelper: PropTypes.shape({
    label: PropTypes.string,
    helperText: PropTypes.string,
    boldLabelText: PropTypes.string,
    boldHeaderText: PropTypes.string,
    imageQuantityRequired: PropTypes.number,
    boldHeaderTextAdditional: PropTypes.string,
    image: PropTypes.string
  }).isRequired,
  handleChange: PropTypes.func.isRequired
};
